export enum MessengerTypeEnum {
  TELEGRAM = "TELEGRAM",
  WHATS_APP = "WHATS_APP",
  VIBER = "VIBER",
  SKYPE = "SKYPE"
}